<template>
    <li> 
        <div v-for="submenuQueMePertenece in submenu.SubmenusQueMePertenecen" v-bind:key="submenuQueMePertenece.SubmenuId" >
            <a v-if="submenuQueMePertenece.EsDescarga == true && submenuQueMePertenece.SeMuestraEnVisor == false" v-on:click="AbrirDocumento(submenuQueMePertenece.RutaParaAccesar, '_self');" class="dropdown-item color-submenu" v-bind:class="{ 'enNegritas': submenu.ResaltarElTitulo }"><i class="fas fa-circle"></i>{{submenuQueMePertenece.Titulo}}</a>
            <a v-else-if="submenuQueMePertenece.EsDescarga == true && submenuQueMePertenece.SeMuestraEnVisor == true" v-on:click="AbreElVisor(submenuQueMePertenece.RutaParaAccesar);" class="nav-link color-submenu" v-bind:class="{ 'enNegritas': submenu.ResaltarElTitulo }"><i class="fas fa-circle"></i>{{submenuQueMePertenece.Titulo}}</a>
            <a v-else-if="submenuQueMePertenece.RutaParaAccesar != null && submenuQueMePertenece.RutaParaAccesar.includes('http')" class="dropdown-item color-submenu" v-on:click="AbrirDocumento(submenuQueMePertenece.RutaParaAccesar, '_blank');" v-bind:class="{ 'enNegritas': submenu.ResaltarElTitulo }"><i class="fas fa-circle"></i>{{submenuQueMePertenece.Titulo}}</a>
            <router-link v-else-if="submenuQueMePertenece.RutaParaAccesar != null" :to="submenuQueMePertenece.RutaParaAccesar" class="dropdown-item color-submenu" v-bind:class="{ 'enNegritas': submenu.ResaltarElTitulo }"><i class="fas fa-circle"></i>{{submenuQueMePertenece.Titulo}}</router-link>
            <a v-else class="dropdown-item dropdown-toggle color-submenu" v-on:click="submenuQueMePertenece.Mostrar = !submenuQueMePertenece.Mostrar;" v-bind:class="{ 'enNegritas': submenu.ResaltarElTitulo }"><i class="fas fa-circle"></i>{{submenuQueMePertenece.Titulo}}</a>
            <div v-if="submenuQueMePertenece.SubmenusQueMePertenecen.length > 0 && submenuQueMePertenece.Mostrar == true" class="dropdown-menu color-submenu">
              <SubmenusQueMePertenecen :submenu="submenuQueMePertenece"></SubmenusQueMePertenecen>
            </div>
        </div>
    </li>
</template>

<script>
export default {
    name: 'submenu',
    props: {
        submenu: Object
    }, 
    components: {
      SubmenusQueMePertenecen: () => import('./Submenus.vue')
    }, 
    methods: {
        AbrirDocumento: function(vinculo, formaDeApertura) {
          
            window.open(vinculo, formaDeApertura);
        },
        AbreElVisor: function(vinculo) {
          
            this.$store.dispatch('A_PaginaOficial_EstableceLaRutaParaElVisor', vinculo);
        }
    }
}
</script>

<style scoped>
.color-submenu{
    color:white !important;
    
}
i {
  font-size: 6px;
  padding-right: 10px;
}
.dropdown-item:hover{
    background-color: rgb(0,117,115);
}
a:active{
    background-color: rgb(0,117,115) !important;
}

@media (max-width: 768px) {
  li {
      font-size: .7rem !important;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/PaginaOficial/PaginaPrincipal/MenuIzquierda/Submenus.vue